import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// =========================================================================
// Auto-update plumbing: register a service worker that network-firsts the
// HTML shell + auto-reloads the tab when a new build is deployed. This is
// the only reliable way to push updates into the Hub-embedded iframe
// where Ctrl+Shift+R on the outer page doesn't refresh the iframe URL.
// =========================================================================
if ("serviceWorker" in navigator) {
  let refreshingFromUpdate = false;
  // When the SW that controls this page changes (i.e. a new SW activated),
  // hard-reload exactly once. This is the moment users see the new build.
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshingFromUpdate) return;
    refreshingFromUpdate = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Probe for an updated worker every 60s while the tab is open. If
        // the user leaves the tab open during a deploy, they'll silently
        // pick up the new build within the minute.
        setInterval(() => {
          reg.update().catch(() => {});
        }, 60_000);
        // Also probe immediately on every tab focus.
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            reg.update().catch(() => {});
          }
        });
      })
      .catch(() => {
        // SW registration failure is non-fatal — the app keeps working,
        // users just don't get the auto-reload benefit. The most common
        // cause is running on http:// instead of https://.
      });
  });
}
